import { DentalProcedure } from '../store/types/prescription';
import { GET_PX_DRAFT } from './constants';
import { RequestResponse } from './fetchAllVisitsForPatient';
import fetchWithRefresh from './fetchWithRefresh';
import { TreatmentPlan } from './getTreatmentPlans';
import { Tool } from './pushVisit';

export interface DraftResponse {
    success: boolean;
    response: Response;
    padVisits?: RequestResponse;
    ongoingTreatmentPlans?: TreatmentPlan[];
    treatmentProcedures?: DentalProcedure[];
}
export interface Response {
    id: string;
    data: Data;
    author?: Author;
    created_at?: string;
    self: boolean;
}

export type Draft = Response;
export interface Data {
    id: string;
    visitId: string;
    tool: Tool;
}

export interface DocEntity {
    name: Name;
    phone: Phone;
}
export interface Name {
    f: string;
    l: string;
}
export interface Phone {
    code: string;
    value: string;
}
export interface Author {
    isStaff: boolean;
    profile: Profile;
}
export interface Profile {
    uuid: string;
    oid: string;
    mn: string;
    ln: string;
    fn: string;
    gen: string;
    'is-p': boolean;
    'is-d': boolean;
    'is-d-s': boolean;
    dob: string;
    mob: string;
    type: number;
    'doc-id': string;
    iat: number;
    exp: number;
}

export default (
    visitId: string,
    ptId?: string,
    fetchOngoingTreatmentPlans?: boolean,
): Promise<DraftResponse> =>
    fetchWithRefresh(GET_PX_DRAFT(visitId, ptId, fetchOngoingTreatmentPlans)).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('failed to fetch px draft');
        }
    });
